// extracted by mini-css-extract-plugin
export default {"controlPanelLabel":"LabelSelector_controlPanelLabel__D0SF7","labelSelection":"LabelSelector_labelSelection__xuImQ","labelSelect":"LabelSelector_labelSelect__XiUu3"};